<template>
  <div class="flex items-center justify-center">
    <div
      v-for="i in max"
      class="text-charcoal-200 dark:text-dark-950"
      @click="emit('update:modelValue', i)"
    >
      <IconBase name="cute/star-gradient" :width="42" v-if="i <= modelValue" />
      <IconBase name="cute/star-fill" :width="42" v-else />
    </div>
  </div>
</template>

<script lang="ts" setup>

const props = withDefaults(defineProps<{
  modelValue: number,
  max?: number,
}>(), {
  max: 5,
})

const emit = defineEmits<{
  (e: 'update:modelValue', v: number): void
}>()

</script>